// src/services/articleService.js
import apiClient from './client';

const endpoint = '/topics';

export const fetchTopics = async () => {
  try {
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};
